module.exports = __webpack_public_path__ + "img/avatar.14f5291c.png";